module.exports = __webpack_public_path__ + "img/email_sent.5befd70d.svg";